export const iconFontAwesomeNatureMosquito = (
	<i className="fa-solid fa-mosquito"></i>
);
